import "./AccordionItem.css";

function AccordionItem({
  number,
  title,
  text,
  image,
  isOpen,
  onClick,
}) {
  return (
    <div className="accordion-item">
      <button
        className="accordion-header"
        onClick={onClick}
      >
        <span className="accordion-number">
          {number}
        </span>

        <span className="accordion-title">
          {title}
        </span>

        <span className="accordion-icon">
          {isOpen ? "−" : "+"}
        </span>
      </button>

      {isOpen && (
        <div className="accordion-content">
          <p>{text}</p>

          <img
            src={image}
            alt={title}
            className="accordion-image"
          />
        </div>
      )}
    </div>
  );
}

export default AccordionItem;